<template>
  <multiselect
    :options="brands"
    :searchable="true"
    :internal-search="false"
    :option-height="104"
    :loading="isSearching"
    :options-limit="50"
    :reset-after="true"
    :show-labels="false"
    :value="brand"
    track-by="id"
    label="title"
    placeholder="Επιλέξτε brand..."
    select-label="Πατήστε enter για επιλογή"
    @search-change="searchBrands"
    @select="selectBrand"
  >
    <template v-slot:option="props" class="option">
      <Photo :photos="props.option.photos" class="option__image" />
      <div class="option__desc">
        <span class="option__title">{{ props.option.title }}</span>
      </div>
    </template>
    <template v-slot:noResult>
      Δε βρέθηκαν αποτελέσματα. Προσπαθήστε ξανά!!
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _debounce from 'lodash/debounce';
import request from '@/utils/request';
import Photo from '@/views/components/Photo';

export default {
  inject: ['$validator'],
  components: {
    Multiselect,
    Photo,
  },
  props: {
    brand: Object,
  },
  data() {
    return {
      brands: [],
      isSearching: false,
    };
  },
  methods: {
    // eslint-disable-next-line func-names
    searchBrands: _debounce(async function(searchQuery) {
      if (searchQuery.length) {
        this.isSearching = true;
        const { data } = await request.get('/brands-search', {
          params: {
            term: searchQuery,
          },
        });
        this.isSearching = false;

        this.brands = data.brands;
      }
    }, 300),
    selectBrand(selectedOption) {
      this.$emit('select-brand', selectedOption);
    },
  },
};
</script>

<style scoped lang="scss">
.multiselect {
  margin: 0 auto;

  .option__desc {
    margin-left: 10px;
  }
}
</style>
